export default [
  'en',
  'en-GB'
]
